(function () {
  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  webvista.subscribe('variant-change', function (event) {
    var variant = event.data && event.data.variant;
    if (!variant) return;

    var sectionId = event.data.sectionId;
    var dataEl = document.getElementById('EnhancedContentData-' + sectionId);
    if (!dataEl) return;

    var allData;
    try {
      allData = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var variantData = allData[String(variant.id)];
    if (!variantData) return;

    // Update images
    var imagesContainer = document.getElementById('EnhancedContent-' + sectionId);
    if (imagesContainer) {
      var images = variantData.images || [];
      var html = '';
      var gridStart = images.length >= 6 ? images.length - 6 : images.length;

      var textItems = variantData.text || [];

      images.forEach(function (url, i) {
        if (i === gridStart) html += '<div class="product-enhanced-grid">';
        var width = i >= gridStart ? '700' : '1400';
        var textHtml = '';
        if (i >= gridStart) {
          var textItem = textItems[i - gridStart];
          if (textItem) {
            textHtml += '<div class="product-enhanced-text">';
            if (textItem.title) textHtml += '<h3 class="product-enhanced-title">' + escapeHtml(textItem.title) + '</h3>';
            if (textItem.paragraph) textHtml += '<p class="product-enhanced-paragraph">' + escapeHtml(textItem.paragraph) + '</p>';
            textHtml += '</div>';
          }
        }
        html += '<div class="product-enhanced-image"><img src="' + url + '" loading="lazy" alt="" width="' + width + '">' + textHtml + '</div>';
        if (i === images.length - 1 && images.length >= 6) html += '</div>';
      });

      imagesContainer.innerHTML = html;
    }

    // Update marketing description
    var descContainer = document.getElementById('EnhancedDesc-' + sectionId);
    if (descContainer && variantData.description != null) {
      descContainer.innerHTML = variantData.description;
    }
  });
})();
